<script setup>
import { ref, computed, watch, onMounted, inject } from 'vue';
import { sortBy } from 'lodash';
import transporte from '@/api/transporte';
import { dateToTimeString } from '../../../libs/dates';

const I18n = inject('I18n');

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  paramsTurnos: {
    type: Object,
    default: () => ({}),
  },
  modelValue: {
    type: [Object, Array],
    default: (rawProps) => {
      if (rawProps.multiple) {
        return [];
      }
      return {};
    },
  },
  editable: { type: Boolean, default: true },
  sortBy: { type: [Array, String], default: () => ['ruta.nombre', 'nombre'] },
});

const emit = defineEmits(['update:modelValue']);

const cargaInicialHecha = ref(false);
const turnos = ref([]);

const turnosOrdenados = computed(() => {
  return sortBy(turnos.value, props.sortBy);
});

const estaSeleccionado = (turno) => {
  if (props.multiple) {
    return !!props.modelValue.find((e) => e.id === turno.id);
  }
  return turno.id === props.modelValue.id;
};

const seleccionarTurno = (turno) => {
  if (props.editable) {
    if (props.multiple) {
      let nuevo = [...props.modelValue];
      if (estaSeleccionado(turno)) {
        nuevo = nuevo.filter((e) => e.id !== turno.id);
      } else {
        nuevo.push(turno);
      }
      nuevo = sortBy(nuevo, props.sortBy);
      emit('update:modelValue', nuevo);
    } else {
      emit('update:modelValue', turno);
    }
  }
};

const inicializarValue = () => {
  if (props.multiple) {
    emit('update:modelValue', []);
  } else {
    emit('update:modelValue', {});
  }
};

const loadTurnos = (params) => {
  if (!Object.keys(params).length) {
    if (cargaInicialHecha.value) {
      inicializarValue();
    }
    return;
  }

  transporte.turnos.get({ params }).then((result) => {
    turnos.value = result.data;
    // Si no es editable solo mostramos el seleccionado
    if (!props.editable) {
      let ids;
      if (Array.isArray(props.modelValue)) {
        ids = props.modelValue.map((e) => e.id);
      } else {
        ids = [props.modelValue.id];
      }
      turnos.value = turnos.value.filter((turno) => ids.includes(turno.id));
    }

    // La primera vez no limpiamos, usamos el valor inicial
    if (cargaInicialHecha.value) {
      // Si no es editable y ya lo hemos cargado, ignoramos
      if (!props.editable) {
        return;
      }
      inicializarValue();
    } else {
      cargaInicialHecha.value = true;
    }
  });
};

watch(
  () => props.paramsTurnos,
  () => {
    if (props.editable || !cargaInicialHecha.value) {
      loadTurnos(props.paramsTurnos);
    }
  },
);

onMounted(() => {
  loadTurnos(props.paramsTurnos);
});
</script>

<template>
  <div class="card">
    <div class="card-header text-center">
      {{ $I18n.t('Turnos') }}
    </div>
    <div class="lista-turnos card-calendar-body-height" style="overflow: auto;">
      <table class="table">
        <tbody>
          <tr
            v-for="turno in turnosOrdenados"
            :key="turno.id"
            class="clickable"
            :class="{ 'active bg-cifra' : estaSeleccionado(turno) }"
            @click="seleccionarTurno(turno)"
          >
            <td>{{ turno.ruta.nombre }}</td>
            <td>{{ turno.nombre }}</td>
            <td>{{ dateToTimeString(turno.hora) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
